<template>
  <div>
    <!-- 顶部导航栏 -->
    <div v-if="showHeader" class="header">
      <div class="logo">
        <img :src="logoSrc" alt="logo" class="logo-img" />
      </div>
      <div class="nav-right" v-if="teamId">
        <div class="userNick" :class="{nickGold}">
          {{nickName}}
        </div>
        <img
          v-if="showLogout"
          :src="logoutSrc"
          alt="logout"
          class="logout-img"
          @click="onLogout"
        />
      </div>
    </div>

    <!-- 音乐图标 -->
    <div v-if="showMusic" class="music-icon" @click="onMusic">
      <img :src="musicSrc" alt="音乐" class="music-img" :class="{ playing: isMusicPlaying }" />
    </div>

    <!-- 左侧装饰箭头 -->
    <div v-if="showLeftArrows" class="left-arrows">
      <img :src="downArrowSrc" alt="箭头" class="arrow-img" />
    </div>
    <div v-if="showLeftArrows" class="left-arrows-down">
      <img :src="downArrowSrc" alt="箭头" class="arrow-img" />
    </div>
  </div>
</template>

<script>
import logoPng from '@/assets/images/loginPage/logo.png'
import logoutPng from '@/assets/images/loginPage/logOut.png'
import musicPng from '@/assets/images/loginPage/musicImg.png'
import downArrowPng from '@/assets/images/loginPage/downArrow.png'
import { toggleBgm } from '@/utils/music'
import { loadTeamId, clearTeamId } from '@/utils/userCache'
import { clearDetailCache } from '@/utils/detailCache'

export default {
  name: 'CommonOverlay',
  props: {
    showHeader: { type: Boolean, default: true },
    showNick: { type: Boolean, default: true },
    showLogout: { type: Boolean, default: true },
    showMusic: { type: Boolean, default: true },
    showLeftArrows: { type: Boolean, default: true },

    // 支持外部替换资源
    logoSrc: { type: [String], default: () => logoPng },
    logoutSrc: { type: [String], default: () => logoutPng },
    musicSrc: { type: [String], default: () => musicPng },
    downArrowSrc: { type: [String], default: () => downArrowPng },
    nickGold: { type: Boolean, default: false },
  },
  computed: {
    isMusicPlaying() {
      return this.$store.state.musicPlaying
    }
  },
  data(){
    return{
      nickName: '',
      teamId: '', // 防止有昵称空的情况
    }
  },
  mounted() {
    // 默认从本地缓存读取昵称（有缓存则覆盖默认文案）
    this.loadNickNameFromCache()
  },
  watch: {
    // 监听 store 中的详情数据变化，当免密登录成功时会触发
    '$store.state.detailData': {
      handler(newData) {
        if (newData && newData.teamName) {
          // 当 store 中有新的详情数据时，重新从缓存读取昵称
          this.loadNickNameFromCache()
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 从本地缓存加载昵称信息
    loadNickNameFromCache() {
      const cached = loadTeamId()
      if (cached) {
        try {
          let cachedObject = JSON.parse(cached)
          this.nickName = cachedObject.nickName || ''
          this.teamId = cachedObject.teamId || ''
        } catch (error) {
          console.error('解析缓存数据失败:', error)
          this.nickName = ''
          this.teamId = ''
        }
      } else {
        this.nickName = ''
        this.teamId = ''
      }
    },
    onNick() {
      this.$emit('nick')
    },
    onLogout() {
      // 若父组件监听了 logout，则仍然走外部逻辑；否则提供默认实现（回到登录页）
      if (this.$listeners && this.$listeners.logout) {
        this.$emit('logout')
        return
      }
      try {
        // 默认退出：清理本地缓存（详情数据 + 昵称）
        clearDetailCache()
        clearTeamId()
        this.$router && this.$router.push({ name: 'login' })
      } catch (e) {
        // ignore
      }
    },
    onMusic() {
      // 若父组件监听了 music，则仍然走外部逻辑；否则默认切换背景音乐
      if (this.$listeners && this.$listeners.music) {
        this.$emit('music')
        return
      }
      toggleBgm().catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: absolute;
  top: .8rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .5rem;
  z-index: 100;

  .logo {
    display: flex;
    align-items: center;

    .logo-img {
      height: 41px;
      width: auto;
    }
  }

  .nav-right {
    display: flex;
    align-items: center;
    gap: 0.2rem;

    .userNick {
      font-size: 24px;
      color: #3B3B3A;
      text-decoration: underline;
      cursor: pointer;
      font-family: 'FontMedium', sans-serif;
    }
    .nickGold{
      color: #EBDAB3 !important;
    }
    .logout-img {
      height: 0.45rem;
      width: auto;
      cursor: pointer;
    }
  }
}

.music-icon {
  position: absolute;
  top: 1.8rem;
  right: 0.5rem;
  z-index: 100;
  cursor: pointer;

  .music-img {
    width: 54px;
    height: 55px;
    display: block;
    &.playing {
      animation: rotate 2s linear infinite;
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.left-arrows {
  position: absolute;
  left: .5rem;
  top: 2.3rem;
  z-index: 10;

  .arrow-img {
    width: 0.35rem;
    height: auto;
    display: block;
  }
}

.left-arrows-down {
  position: absolute;
  left: .5rem;
  bottom: 2.3rem;
  z-index: 10;

  .arrow-img {
    width: 0.35rem;
    height: auto;
    display: block;
  }
}
</style>
